export default "__VITE_ASSET__9ed7f4fc__"